if (!customElements.get('natunora-listicle-studio')) {
  customElements.define('natunora-listicle-studio', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const track = event => {
        if (event.type === 'auxclick' && event.button !== 1) return;
        const position = event.target.closest('[data-studio-cta]')?.dataset.studioCta;
        if (!/^(reason-([1-9]|1[0-2])|closing)$/.test(position || '')) return;
        try {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.clarity === 'function') {
            window.clarity('event', `natunora_studio_${position.replace('-', '_')}_offer_click`);
          }
        } catch (_) {}
      };
      for (const type of ['click', 'auxclick']) this.addEventListener(type, track, { capture: true, signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
